<ngb-pagination [collectionSize]="collectionSize"
                [(page)]="page"
                [boundaryLinks]="true"
                (pageChange)="loadPage($event)"
                [pageSize]="pageSize"
                [maxSize]="maxSize"
                [rotate]="true"
                [ellipses]="false"
                [ngStyle]="{'float':float}"></ngb-pagination>